import { Component, Input, Output, EventEmitter } from "@angular/core";
@Component({
    selector: "kpi-host-menu-option",
    templateUrl: "./kpiHostMenuOption.component.html",
    standalone: false
})
export class KpiHostMenuOptionComponent {
    @Input() public optionId: string = "";
    @Input() public text: string;
    @Output() public click: EventEmitter<void> = new EventEmitter<void>();

    public raiseClick(event: Event): void {
        if (event) event.stopPropagation();
        this.click.emit();
    }
}